import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AppRouter, { history } from './routers/AppRouter';
import configureStore from './store/configureStore';
import { login, logout } from './actions/auth';
import LoadingPage from './components/LoadingPage';
import { getBeneficiary, getCountryData, getPartenaire, getCgu, getStateHeadingData } from './api/api';
import { setBeneficiary } from './actions/beneficiary';
import { setCountry } from "./actions/country";
import { getStateHeadings } from './actions/Dashboard';
import { setPartenaire } from "./actions/partenaire";
import { setCgu } from "./actions/cgu";

import 'normalize.css/normalize.css';
import './styles/styles.scss';
import 'react-dates/lib/css/_datepicker.css';
import 'moment/locale/fr';
import 'rc-datepicker/lib/style.css';

import { initializeGtm } from './utils/gtmUtils';
 
initializeGtm();

const store = configureStore();
const user = JSON.parse(sessionStorage.getItem('auth'));

// let minutes = 1; // Reset when storage is more than 24hours
// let now = new Date().getTime();
// let setupTime = sessionStorage.getItem('setupTime');
// if (setupTime == null) {
//   sessionStorage.setItem('setupTime', now)
// } else {
//     if(now-setupTime > minutes*6000) {
//       sessionStorage.clear()
//       sessionStorage.setItem('setupTime', now);
//     }
// }

const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
);
let hasRendered = false;
const renderApp = () => {
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById('app'));
    hasRendered = true;
  }
};

ReactDOM.render(<LoadingPage />, document.getElementById('app'));
ReactDOM.render(jsx, document.getElementById('app'));

if (user && user.uid) {
  console.log('-----App.js----');
  sessionStorage.setItem('activeSession', 'true');
  getPartenaire().then((response) => {
    store.dispatch(setPartenaire(response.data));
    const partnerId = response.data.data.id;
    getBeneficiary(sessionStorage.defaultID).then((response) => {
      sessionStorage.setItem('benef', JSON.stringify(response.data));
      store.dispatch(setBeneficiary(response.data));
      getStateHeadingData(response.data.idBeneficiaire, partnerId, sessionStorage.defaultID).then((response) => {
        store.dispatch(getStateHeadings(response.data));
      });
    });
  });

  store.dispatch(login(user.uid, sessionStorage.defaultID));
  // load countries
  getCountryData().then((response) => {
    store.dispatch(setCountry(response.data));
  });

  getCgu().then((response) => {
    store.dispatch(setCgu(response.data));
  });
  
  renderApp();
} else {
  getPartenaire().then((response) => {
    store.dispatch(setPartenaire(response.data));
    if ( response.data.partenaireFavicon && response.data.partenaireFavicon.base64 ) {
      sessionStorage.setItem("favicon64", response.data.partenaireFavicon.base64);
    }
  });
  getCgu().then((response) => {
    store.dispatch(setCgu(response.data));
  });
  store.dispatch(logout());
  renderApp();
}
// window.addEventListener("beforeunload", function (e) {
//   if (user && user.uid) {
//     store.dispatch(login(user.uid));
//   }
// })

// window.addEventListener("onload", function (e) {
//   store.dispatch(logout());
//   sessionStorage.removeItem('auth');
//   sessionStorage.removeItem('defaultID');
// });

// window.addEventListener("beforeunload", function (e) {
//   let activeSession = sessionStorage.activeSession;
//   if (sessionStorage.loggedOutOnAuth) {
//     console.log('Logged out due to expiry already')
//   }
//   else if (!activeSession) {
//     sessionStorage.loggedOutOnAuth = true;
//     console.log('ok');
//     //  _logout()
//   }
// });




// WEBPACK FOOTER //
// ./src/app.js